import React from "react";
import RegistrarFormatos from "../../components/RegistrarFormatos/RegistrarFormato"; //Se importa el componente para los catálogos

export default function RegistrarFormatoPrincipal(props) {
    return (
        <RegistrarFormatos
            idFormato={""}
            casillaEspecial={""}
            idGeografico={""}
            observaciones={""}
            participacion={""}
            seccion={""}
            secretario={""}
            escrutador={""}
            distrito={""}
            accion={""}
           

        />
    );
}